<div data-qa-block="certificate-info">
  <p class="block_title" translate data-qa="block-title">organization.certificate.legal.data</p>
  <div class="user__parameter">
    <span translate data-qa="organization-name-title">organization.full.name</span>
    <span data-qa="organization-name">{{ organization?.title }}</span>
  </div>

  <div class="user__parameter">
    <span translate data-qa="iin-bin-title">organization.iin-bin</span>
    <span data-qa="iin-bin">{{ organization?.inn }}</span>
  </div>

  <div class="user__parameter">
    <span translate data-qa="oked-title">organization.oked</span>
    <span data-qa="oked">{{ organization?.okved }}</span>
  </div>
</div>

<hr class="greyline" />

<div data-qa-block="manager">
  <p class="block_title" translate data-qa="block-title">organization.manager</p>
  <div class="user__parameter">
    <span translate data-qa="manager-position-title">organization.manager.vacancy</span>
    <span data-qa="manager-position">{{ organization?.generalManagerPosition?.name }}</span>
  </div>
  <div class="user__parameter">
    <span translate data-qa="manager-fio-title">organization.manager.fio</span>
    <span data-qa="manager-fio">{{ organization?.generalManager }}</span>
  </div>
</div>

<hr class="greyline" />

<div data-qa-block="bank-data">
  <p class="block_title" translate data-qa="block-title">organization.payment</p>
  <div class="user__parameter">
    <span translate data-qa="bank-name-title">organization.bank</span>
    <span data-qa="bank-name">{{ organization?.bankData.name }}</span>
  </div>
  <div class="user__parameter">
    <span translate data-qa="bic-title">organization.bic</span>
    <span data-qa="bic">{{ organization?.bankData.bic }}</span>
  </div>
  <div class="user__parameter">
    <span translate data-qa="iik-title">organization.iik</span>
    <span data-qa="iik">{{ organization?.bankData.paymentAccount }}</span>
  </div>
</div>

<hr class="greyline" />

<div data-qa-block="organization-contacts">
  <p class="block_title" translate data-qa="block-title">organization.contacts</p>
  <div class="user__parameter">
    <span translate data-qa="legal-address-title">organization.legal.address</span>
    <span data-qa="legal-address">{{ organization?.legalAddress }}</span>
  </div>
  <div class="user__parameter">
    <span translate data-qa="actual-address-title">organization.actual.address</span>
    <span data-qa="actual-address" [ngClass]="{ disabled: isSameAddress }">{{
      organization?.actualAddress
    }}</span>
  </div>
  <div class="user__parameter">
    <span translate data-qa="email-title">organization.email</span>
    <span data-qa="email">{{ organization?.responsiblePerson.email }}</span>
  </div>
  <div class="user__parameter">
    <span translate data-qa="phone-title">organization.phone</span>
    <span data-qa="phone">{{ organization?.responsiblePerson.phone }}</span>
  </div>
</div>
